_ = require('lodash')

GroupRegisDataService = ($http ,$q ,groupUploadDataService )  ->
  tempData = undefined
  setTempData: (data) ->
    tempData = data
  getTempData: ->
    return tempData
  createGroup: (group , dataCover , dataAvatar) ->
    defer = $q.defer()
    promise =
      urlDataCover: groupUploadDataService.uploadS3(dataCover.coverFile ,dataCover.url , dataCover.fields )
      urlAvatar:  groupUploadDataService.uploadS3(dataAvatar.coverFile ,dataAvatar.url , dataAvatar.fields)

    $q.all(promise).then (data) ->
      group.cover_path = data.urlDataCover
      group.avatar_path = data.urlAvatar
      group.public_status = group.type == '1'
      $http.post('/api/groups.json', group)
        .then (data) ->
          defer.resolve 'success'
        , (data) ->
          defer.reject data
    defer.promise

  createS3ImageURL: (data) ->
    $http.post '/api/images.json', { prefix : data }

  getGroup:(id) ->
    url = "/api/groups/#{id}.json"
    delay = $q.defer()
    $http.get(url).then (resp) ->
      delay.resolve resp.data
    .catch (resp, status) ->
      delay.reject resp.data
    delay.promise

  updateGroup: (group , dataCover , dataAvatar) ->
    defer = $q.defer()
    promise =
      urlDataCover: groupUploadDataService.uploadS3(dataCover.coverFile ,dataCover.url , dataCover.fields )
      urlAvatar:  groupUploadDataService.uploadS3(dataAvatar.coverFile ,dataAvatar.url , dataAvatar.fields)

    $q.all(promise).then (data) ->
      if data.urlDataCover != '' && (data.urlDataCover + '').length > 0
        group.cover_path = data.urlDataCover
      if data.urlAvatar  != '' && (data.urlAvatar + '').length > 0
        group.avatar_path = data.urlAvatar

      group.public_status = group.type == '1'
      $http.put("/api/groups/#{group.id}.json", group)
        .then (data) ->
          defer.resolve 'success'
        , (data) ->
          defer.reject data
    defer.promise
  searchGroup:(key , pageNum , pageSize) ->
    defer = $q.defer()
    url = '/api/groups/search.json'
    params =
      keyword : key
      page : pageNum
      page_size: pageSize

    $http.get(url , params: params).then (resp) ->
      defer.resolve resp.data
    .catch (resp, status) ->
      defer.reject resp.data
    defer.promise

  joinGroup:(params) ->
    $http.post '/api/group_entries.json', params

  groupStatus:(groupId) ->
    defer = $q.defer()
    url = '/api/users/join_group.json'
    params =
      group_id : groupId
    $http.get(url , params: params).then (resp) ->
      defer.resolve resp.data
    .catch (resp, status) ->
      defer.reject resp.data
    defer.promise

GroupRegisDataService.$inject = [
  '$http'
  '$q'
  'groupUploadDataService'
]

module.exports = GroupRegisDataService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-registration-data-service.coffee